import { gql } from "@apollo/client";
import FeatureCardFragment from '@components/FeatureCard/FeatureCard.fragment';
import { CampaignHeroFragment, DonateHeroFragment, ShortHeroFragment, TallHeroFragment, VideoHeroFragment,VoucherHeroFragment, TallHero200Fragment, ShortHero200Fragment } from '@components/Hero/Hero.fragment';



export default gql`
  ${ShortHeroFragment}
  ${ShortHero200Fragment}
  ${VideoHeroFragment}
  ${TallHeroFragment}
  ${TallHero200Fragment}
  ${CampaignHeroFragment}
  ${DonateHeroFragment}
  ${FeatureCardFragment}
  ${VoucherHeroFragment}

  fragment WhatsonListingFragment on WhatsonPage {
    metatags {
      metaTitle
      metaRobots
      metaImage {
        md
      }
      metaDescription
      canonical
    }
    hero {
      ...ShortHeroParagraph
      ...TallHeroParagraph
      ...VideoHeroParagraph
      ...CampaignHeroParagraph
      ...VoucherHeroParagraph
      ...DonateHeroParagraph
      ...TallHero200Paragraph
      ...ShortHero200Paragraph
    }
    featuredCard {
      ...FeatureCardFragment
    }
    content {
      alignment
      text {
        processed
        format
        value
      }
    }
    searchFilters {
      name
      values
    }
    searchResults {
      total
      pageSize
      page
      totalPages
      resultList {
        id
        title
        path
        target
        startDate
        teaserImage {
          id
          altText
          url
          sm
          md
          lg
          xl
        }
        teaserDescription
        teaserEyebrow
        label
        filters
      }
    }
  }
`;

export const SearchFilterFragment = gql`
  fragment SearchFilterFragment on SearchFilter {
    name
    values
  }
`;

export const WhatsonResultsFragment = gql`
  fragment WhatsOnResultsFragment on WhatsonResults {
    page
    totalPages
    resultList {
      id
      title
      path
      startDate
      teaserImage {
        id
        altText
        url
      }
      teaserDescription
      teaserEyebrow
      label
      filters
    }
  }
`;
